<template>
  <div id="app">
    <el-container class="main">
      <el-header style="padding: 10px; height: 90px">
        <venusmenu></venusmenu>
      </el-header>
      <el-main style="padding: 0px;flex-basis: 0">
        <router-view />
      </el-main>
      <el-footer class="footer" style="height: 30px" align="center">
        私人定制, 粤ICP备18087913号
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import venusmenu from '@/components/venus_menu'
import maincontent from '@/components/main_content'

export default {
  name: 'App',
  components: {
    venusmenu,
    maincontent
  },
  mounted () {
    document.title = '私人网站 bergtan'
  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.main {
  position: fixed;
  top: 0px;
  right: 0;
  margin: 0 auto;
  border: 1px solid royalblue;
  background-color: rgb(241, 241, 241);
  height: 100%;
  width: 100%;
  bottom: 20px;
}

.head {
  height: 60px;
  width: 100%;
  float: left;
  font-family: "Open Sans", sans-serif;
  background: #fff;
  /* box-shadow: 0 1px 3px #dedede; */
  z-index: 2;
}

.content {
  width: 100%;
  height: 100%;
  background: #fff;
  padding-top: 70px;
  padding-bottom: 20px;
  z-index: 1;
}

.footer {
  background-color: rgb(157, 190, 219);
}

a {
  text-decoration: none;
}

a:link {
  color: black;
} /* 未被访问的链接 */
a:visited {
  color: black;
} /* 已被访问的链接 */
a:hover {
  color: black;
} /* 鼠标指针移动到链接上 */
a:active {
  color: black;
} /* 正在被点击的链接 */
</style>



// WEBPACK FOOTER //
// src/App.vue